export const pricingData = {
  navItems: [
    { label: "料金体系", anchor: "#price-structure" },
    { label: "月額サービス", anchor: "#monthly-support" },
    { label: "初期導入", anchor: "#initial-support" },
    { label: "制作・開発", anchor: "#production-dev" },
    { label: "保守・運用", anchor: "#maintenance" },
    { label: "契約について", anchor: "#contract-section" },
    { label: "よくある質問", anchor: "#faq" },
  ],

  hero: {
    breadcrumbs: [
      { label: "ホーム", href: "/" },
      { label: "料金・契約について", href: null },
    ],
    label: "PRICE & CONTRACT",
    mainCopy: "必要な支援だけを、\n分かりやすい料金で。",
    description:
      "ノーブルラボでは、月額伴走支援、AI・デジタル導入支援、制作・システム開発、保守運用を分けてご案内します。料金の目安を掲載し、必要な作業と費用を実施前に明確にします。",
    tags: [
      { label: "月額伴走", icon: "ri-calendar-check-line" },
      { label: "スポット支援", icon: "ri-flashlight-line" },
      { label: "制作・開発", icon: "ri-code-s-slash-line" },
      { label: "事前見積り", icon: "ri-file-list-3-line" },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20organic%20background%20with%20soft%20layered%20flowing%20shapes%20in%20cream%20beige%20and%20warm%20neutral%20tones%2C%20subtle%20paper%20texture%2C%20gentle%20curved%20flowing%20forms%2C%20minimal%20artistic%20composition%2C%20soft%20warm%20orange%20amber%20accents%2C%20no%20people%20no%20text%20no%20objects%2C%20Japanese%20editorial%20abstract%20art%2C%20calm%20professional%20atmosphere%2C%20gentle%20gradient%20of%20light%20warm%20tones%2C%20suitable%20for%20website%20hero%20background&width=1920&height=1080&seq=pricing-hero-bg&orientation=landscape",
  },

  priceStructure: {
    label: "PRICE STRUCTURE",
    title: "料金は、大きく4つに分かれます。",
    note: "現在の環境やご相談内容に応じて、必要な支援のみをご提案します。",
    items: [
      {
        num: "01",
        title: "月額伴走支援",
        desc: "毎月のミーティング、相談、課題整理、改善提案、運用確認などを継続して行います。",
        services: ["DX顧問 50,000円〜", "AI事務局サポート 30,000円〜"],
        icon: "ri-calendar-check-line",
      },
      {
        num: "02",
        title: "AI・デジタル導入支援",
        desc: "支援開始時の業務整理、利用環境の整備、アカウント設定、ルールやテンプレートの作成などを行います。",
        services: ["100,000円〜"],
        icon: "ri-rocket-line",
      },
      {
        num: "03",
        title: "制作・システム開発",
        desc: "ホームページ、申込フォーム、予約システム、会員管理、チャットボットなどを制作・開発します。",
        services: ["個別見積"],
        icon: "ri-code-s-slash-line",
      },
      {
        num: "04",
        title: "保守・運用支援",
        desc: "制作・開発したウェブサイトやシステムについて、必要に応じて月額の保守・運用支援を行います。",
        services: ["月額20,000円〜"],
        icon: "ri-settings-3-line",
      },
    ],
  },

  monthlySupport: {
    label: "MONTHLY SUPPORT",
    title: "月額伴走サービス",
    note: "DX顧問は会社全体を対象にする支援、事務局サポートは対象業務を事務局運営に絞った基本支援です。価格差は支援範囲の違いによるものであり、サービスの優劣を表すものではありません。",
    plans: [
      {
        name: "DX顧問",
        target: "中小企業・小規模事業者",
        pricing: "月額 50,000円〜",
        pricingDetail: "会社全体の業務改善、AI・IT・ウェブ活用、改善の優先順位整理。",
        icon: "ri-user-star-line",
        features: [
          "月1回の定例ミーティング",
          "契約範囲内での随時相談",
          "業務課題と優先順位の整理",
          "改善施策の提案",
          "ツール選定に関する助言",
          "次回までのアクション整理",
        ],
        linkLabel: "DX顧問の詳細を見る",
        linkHref: "/service/dx-consultant",
      },
      {
        name: "伴走型AI事務局サポート",
        target: "少人数で事務局を運営する社団法人・NPO法人、会員組織、地域団体など",
        pricing: "月額 30,000円〜",
        pricingDetail: "年間予定、会議・会員管理・情報共有など、事務局運営の整理と改善。",
        icon: "ri-team-line",
        features: [
          "月1回のオンライン定例ミーティング",
          "年間予定と直近業務の確認",
          "契約範囲内での軽微な相談",
          "AIを活用した案内文・議事録などへの助言",
          "事務局業務の課題整理",
          "次回までのアクション整理",
        ],
        linkLabel: "伴走型AI事務局サポートの詳細を見る",
        linkHref: "/service/ai-office",
      },
    ],
  },

  initialSupport: {
    label: "INITIAL SUPPORT",
    title: "AI・デジタル導入支援",
    pricing: "100,000円〜",
    description:
      "現在の業務や利用環境を確認し、AIやデジタルツールを利用するための初期環境、ルール、業務の進め方を整えます。",
    items: [
      { label: "業務と課題のヒアリング", icon: "ri-search-line" },
      { label: "利用中のツールやデータの確認", icon: "ri-folder-line" },
      { label: "課題一覧と優先順位の整理", icon: "ri-file-list-3-line" },
      { label: "Google Workspaceや生成AIの初期設定", icon: "ri-robot-line" },
      { label: "共有フォルダ構成の整理", icon: "ri-folder-shared-line" },
      { label: "AI利用ルールの作成", icon: "ri-shield-check-line" },
      { label: "テンプレートや簡易手順書の作成", icon: "ri-file-copy-line" },
      { label: "操作説明・研修", icon: "ri-presentation-line" },
    ],
    note: "設定するサービス、対象人数、データ整理、研修などの範囲によって費用が変わります。",
  },

  productionDev: {
    label: "PRODUCTION & DEVELOPMENT",
    title: "制作・システム開発",
    pricing: "個別見積",
    description:
      "必要な機能、利用人数、外部サービスとの連携、運用方法などを確認したうえでお見積りします。",
    items: [
      { label: "ホームページ制作・改修", icon: "ri-window-line" },
      { label: "申込フォーム", icon: "ri-survey-line" },
      { label: "施設予約システム", icon: "ri-calendar-todo-line" },
      { label: "会員管理ツール", icon: "ri-group-line" },
      { label: "FAQ・チャットボット", icon: "ri-chat-smile-2-line" },
      { label: "Google Apps Scriptによる自動化", icon: "ri-settings-5-line" },
      { label: "小規模な業務ツール", icon: "ri-tools-line" },
      { label: "データ移行・外部サービス連携", icon: "ri-plug-line" },
    ],
    note: "顧問契約では、必要性の整理や仕様の検討を支援します。実際の制作・開発作業は原則として別途お見積りします。",
  },

  maintenance: {
    label: "MAINTENANCE",
    title: "ウェブサイト・業務ツールの保守運用",
    pricing: "月額 20,000円〜",
    description:
      "制作したウェブサイトや小規模な業務ツールを、継続して安全に利用するための保守・運用支援です。",
    items: [
      { label: "WordPressやプラグインの更新", icon: "ri-refresh-line" },
      { label: "SSL証明書やサーバー環境の確認", icon: "ri-shield-keyhole-line" },
      { label: "バックアップ", icon: "ri-archive-line" },
      { label: "動作確認", icon: "ri-check-double-line" },
      { label: "軽微な不具合への対応", icon: "ri-bug-line" },
      { label: "運用に関する相談", icon: "ri-chat-3-line" },
    ],
    note: "独自システム、外部サービスとの連携、利用者数が多いシステムなどは、内容に応じて個別にお見積りします。",
  },

  scope: {
    label: "SCOPE",
    title: "月額料金に含まれる範囲",
    note: "別途費用が必要な場合は、作業を始める前に内容と費用をご説明します。",
    monthlyNote:
      "月額料金は、定例ミーティング、相談、課題整理、改善提案、運用確認を中心とした料金です。制作・開発、大量のデータ整理、長時間の作業、訪問、資料作成などは、契約範囲を超える場合に別途お見積りします。",
    included: {
      title: "月額料金に含まれる主な内容",
      items: [
        "定例ミーティング",
        "契約範囲内での随時相談",
        "現在の課題と状況の確認",
        "改善施策の検討と提案",
        "ツールやサービス選定の助言",
        "軽微な設定・操作支援",
        "運用状況の確認",
        "月次記録と次のアクション整理",
      ],
    },
    excluded: {
      title: "原則として別途費用になる主な内容",
      items: [
        "ホームページ制作・大規模改修",
        "システム・業務ツール開発",
        "大量のデータ入力やデータ移行",
        "長時間の現地作業",
        "写真撮影、取材、原稿作成",
        "郵送、印刷、発送などの事務作業",
        "有料サービスやライセンス料金",
        "パソコンやネットワーク機器の修理",
        "法律、税務、労務など専門資格が必要な判断",
      ],
    },
  },

  priceFactors: {
    label: "PRICE FACTORS",
    title: "支援内容と関わり方で料金が確定",
    intro:
      "組織が大きいほど必ず高くなるわけではなく、必要な支援量に応じて費用が決まります。以下の要素を確認したうえで、ご提案します。",
    items: [
      { label: "定例ミーティングの回数と時間", icon: "ri-time-line" },
      { label: "訪問またはオンラインの頻度", icon: "ri-global-line" },
      { label: "随時相談の方法と範囲", icon: "ri-chat-check-line" },
      { label: "対象となる業務や部署の数", icon: "ri-building-2-line" },
      { label: "利用者・会員・アカウント数", icon: "ri-user-line" },
      { label: "現在のデータやファイルの状態", icon: "ri-folder-line" },
      { label: "初期設定や環境整備の有無", icon: "ri-settings-3-line" },
      { label: "実作業や代行作業の量", icon: "ri-task-line" },
      { label: "制作・開発の有無", icon: "ri-code-s-slash-line" },
      { label: "保守・運用の範囲", icon: "ri-shield-check-line" },
    ],
  },

  planExamples: {
    label: "PLAN EXAMPLES",
    title: "課題に応じて、必要な支援をご提案",
    note: "以下は契約の組み合わせ例であり、固定の料金プランではありません。すべての契約で、初期費用、開発費、保守費が発生するわけではありません。",
    examples: [
      {
        id: 1,
        title: "相談相手がほしい中小企業",
        items: ["DX顧問", "月次ミーティング", "随時相談", "課題整理と改善提案"],
        priceLabel: "月額伴走支援",
        priceValue: "月額50,000円〜",
        icon: "ri-user-star-line",
      },
      {
        id: 2,
        title: "事務局業務を整理したい団体",
        items: ["AI・デジタル導入支援", "伴走型AI事務局サポート"],
        priceLabel: "初期費用＋月額伴走支援",
        priceValue: "初期費用100,000円〜 ＋ 月額30,000円〜",
        note: "初期整備が不要な場合は、月額支援から開始できる場合があります。",
        icon: "ri-team-line",
      },
      {
        id: 3,
        title: "業務ツールも必要な組織",
        items: ["DX顧問 または 伴走型AI事務局サポート", "制作・システム開発（個別見積）", "必要に応じた保守運用"],
        priceLabel: "月額伴走＋制作・開発＋保守運用",
        priceValue: "制作・開発費は個別見積",
        icon: "ri-stack-line",
      },
    ],
  },

  estimateFlow: {
    label: "ESTIMATE FLOW",
    title: "現在の状況を確認してから、支援内容と費用をご提案",
    note: "内容にご納得いただいてから契約・作業開始となります。",
    steps: [
      {
        num: "01",
        title: "お問い合わせ",
        desc: "現在の困りごとや検討している支援についてお知らせください。",
        icon: "ri-mail-send-line",
      },
      {
        num: "02",
        title: "ヒアリング",
        desc: "業務内容、利用環境、担当者、希望する支援範囲を確認します。",
        icon: "ri-chat-3-line",
      },
      {
        num: "03",
        title: "支援内容の整理",
        desc: "月額支援、初期整備、制作・開発など、必要な項目を整理します。",
        icon: "ri-file-list-3-line",
      },
      {
        num: "04",
        title: "お見積り・ご提案",
        desc: "支援内容、対応範囲、費用、進め方をご説明します。",
        icon: "ri-file-text-line",
      },
    ],
  },

  contract: {
    label: "CONTRACT",
    title: "契約内容と対応範囲を、事前に明確化",
    note: "詳細な条件は、お見積りおよび契約書にてご案内します。",
    items: [
      { label: "契約するサービス", icon: "ri-file-list-2-line" },
      { label: "定例ミーティングの回数", icon: "ri-calendar-check-line" },
      { label: "随時相談の方法と範囲", icon: "ri-chat-check-line" },
      { label: "月額内に含まれる作業", icon: "ri-check-line" },
      { label: "別途見積となる作業", icon: "ri-price-tag-3-line" },
      { label: "訪問対応の条件", icon: "ri-map-pin-line" },
      { label: "交通費・実費", icon: "ri-train-line" },
      { label: "契約期間", icon: "ri-calendar-line" },
      { label: "支払方法", icon: "ri-bank-card-line" },
      { label: "解約条件", icon: "ri-close-circle-line" },
      { label: "機密情報・個人情報の取り扱い", icon: "ri-lock-line" },
    ],
  },

  faq: {
    label: "FAQ",
    title: "よくある質問",
    items: [
      {
        q: "料金だけ先に教えてもらえますか",
        a: "支援範囲によって費用が変わるため、現在の状況を簡単に伺ったうえでご案内します。",
      },
      {
        q: "表示されている最低料金で、どこまで対応してもらえますか",
        a: "最低料金は、月1回の定例ミーティング、契約範囲内での相談、課題整理、改善提案などを中心とした基本料金です。訪問、設定作業、制作、開発などは内容に応じて別途ご案内します。",
      },
      {
        q: "伴走型AI事務局サポートは、月額30,000円だけで事務作業を代行してもらえますか",
        a: "月額30,000円からのプランは、事務局業務の整理、相談、改善提案、AI活用支援を中心としています。日常業務の代行、大量の入力、資料作成などは別途ご相談となります。",
      },
      {
        q: "月額料金は途中で変わることがありますか",
        a: "支援範囲、訪問回数、実作業量などを変更する場合は、事前に相談したうえで契約内容と料金を見直します。",
      },
      {
        q: "初期費用は必ず必要ですか",
        a: "現在の利用環境や業務の整理状況によって異なります。初期整備が不要な場合は、月額支援から開始できることもあります。",
      },
      {
        q: "単発の相談や導入支援もできますか",
        a: "はい。生成AIやGoogle Workspaceの導入、業務整理、研修など、スポットでの支援もご相談いただけます。",
      },
      {
        q: "DX顧問と事務局サポートの違いは何ですか",
        a: "DX顧問は中小企業や小規模事業者の業務改善全般を対象とし、伴走型AI事務局サポートは会員組織や団体の事務局運営に特化しています。価格差は支援範囲の違いによるものであり、サービスの優劣を表すものではありません。",
      },
      {
        q: "ホームページ制作やシステム開発だけでも依頼できますか",
        a: "内容に応じて対応します。ウェブ制作については、株式会社ノーブルウェブのウェブ制作事業部と連携します。",
      },
      {
        q: "訪問費用は月額料金に含まれますか",
        a: "契約内容、訪問地域、訪問回数によって異なります。見積り時に条件をご説明します。",
      },
      {
        q: "保守料金は顧問料に含まれますか",
        a: "ウェブサイトやシステムの保守は、原則として別途ご提案します。契約内容によっては一体でご案内する場合もあります。",
      },
    ],
  },

  cta: {
    label: "CONTACT",
    heading: "自社・自団体の場合の費用を、一度考えてみませんか。",
    description:
      "サービスや料金が決まっていない段階でも問題ありません。現在の課題、希望する支援、利用環境を伺い、必要な内容と費用をご案内します。",
    beforeFormPoints: [
      "何も決まっていない段階でも相談可能",
      "必要な支援だけを提案",
      "別途費用は作業前に案内",
      "無理なシステム導入を前提にしない",
    ],
    inquiryTypes: [
      "DX顧問の料金について",
      "伴走型AI事務局サポートの料金について",
      "AI・デジタル導入支援について",
      "制作・システム開発について",
      "保守・運用について",
      "その他",
    ],
  },
};